import { GENERATE_USER_API_TOKEN, GENERATE_USER_API_TOKEN_SUCCESS, GENERATE_USER_API_TOKEN_FAILURE } from '../constants/generate_user_api_token.constants';

export const generateUserAPITokenRequest = data => ({
    type: GENERATE_USER_API_TOKEN,
    data,
});

export const generateUserAPITokenSuccess = payload => ({
    type: GENERATE_USER_API_TOKEN_SUCCESS,
    payload,
});

export const generateUserAPITokenFailure = error => ({
    type: GENERATE_USER_API_TOKEN_FAILURE,
    error,
});



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/actions/generate_user_api_token.actions.js